/**
 * General constant used to flag error logs coming from Monicore package
 */
export const MONICORE = 'monicore';

/**
 * Available platforms
 */
export const PLATFORMS = {
    MOBILE_WEB: 'mobile_web',
    WEB: 'web',
};
